import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  background-color: #393939;
  border-radius: 1rem;
  padding: ${props => props?.customPadding || '1.5rem'};
  position: relative;
  overflow: hidden;
  color: #f2f2f2;
`;

export const TopContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5rem;
  margin-top: -0.5rem;
  margin-right: -0.5rem;
  margin-bottom: 0.25rem;
`;

export const IconButton = styled.button`
  background-color: transparent;
  color: inherit;
  border: none;
  cursor: pointer;
`;

export const BottomContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5rem;
  margin-top: 1rem;
`;

export const CancelButton = styled.button`
  background-color: transparent;
  color: #f2f2f2;
  border: none;
  padding: 0.5rem 0.5rem;
  font-family: Montserrat;
  font-size: 1rem;
  font-weight: 500;
  transition: all 0.15s;
  cursor: pointer;

  &:hover {
    transform: scale(0.98);
  }
`;

export const SubmitButton = styled.button`
  background-color: #ff7417;
  color: #f2f2f2;
  border: none;
  padding: 0.5rem 1.5rem;
  font-family: Montserrat;
  font-size: 1rem;
  font-weight: 500;
  border-radius: 0.25rem;
  transition: all 0.15s;
  cursor: pointer;

  &:hover {
    transform: scale(0.98);
  }
`;